import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const WheelchairSVG = styled(Icon).attrs({ viewBox: '0 0 10 12.001' })`
    width: 0.8332638947em;
`;

const Wheelchair = ({ color = navy, ...props }) => (
    <WheelchairSVG
        data-icon="icon-wheelchair"
        {...props}
    >
        <path
            d="M7.98 10.686L7.215 8.8l-.75-1.848h-1.87c-1.027 0-1.868-.001-1.869-.002l-.182-2.683-.183-2.68-.03-.066a1.109 1.109 0 0 1-.094-.415 1.06 1.06 0 0 1 .83-1.09 1.078 1.078 0 0 1 .387.005 1.024 1.024 0 0 1 .7.56 1.042 1.042 0 0 1 .112.485 1.084 1.084 0 0 1-.416.861 1.024 1.024 0 0 1-.45.196l-.053.006.004.045c.004.054.112 2.066.112 2.098v.022h2.612v1H3.56l.005.063.023.343.02.278.346-.005c.783-.01 3.126-.022 3.132-.016.003.004.338.814.744 1.8s.74 1.79.745 1.79.256-.094.562-.21.558-.208.56-.206c.011.012.308.764.304.769s-1.963.813-1.99.82c-.01.004-.019-.006-.03-.033m-4.506 1.309a3.69 3.69 0 0 1-.906-.193 3.913 3.913 0 0 1-2.522-3.09 6.504 6.504 0 0 1-.035-.257 6.828 6.828 0 0 1 0-.78A4.127 4.127 0 0 1 .373 6.36a3.9 3.9 0 0 1 1.704-1.817l.106-.056.005.046c.005.048.08 1.08.08 1.103a.236.236 0 0 1-.069.061 2.77 2.77 0 0 0-.485.448 2.974 2.974 0 0 0-.675 1.526 2.224 2.224 0 0 0-.019.382 2.43 2.43 0 0 0 .038.53 2.881 2.881 0 0 0 .763 1.514 2.571 2.571 0 0 0 .425.364 2.603 2.603 0 0 0 2.19.376 2.496 2.496 0 0 0 .542-.223 2.853 2.853 0 0 0 1.291-1.478 3.12 3.12 0 0 0 .163-.61.604.604 0 0 1 .02-.1c.002 0 .15.317.33.704l.328.704-.043.083a3.88 3.88 0 0 1-2.094 1.867 3.6 3.6 0 0 1-.83.2 5.4 5.4 0 0 1-.669.012"
            fill={color}
        />
    </WheelchairSVG>
);

export {
    Wheelchair as default,
    Wheelchair,
};
